import { Permission, type User } from "@/model/RootStore"

export enum FieldAccess {
	Public = "public",
	Authenticated = "authenticated",
	Sensitive = "sensitive",
}

export type FieldVisibility = FieldAccess | Permission

export function canAccessField(user: User, visibility: FieldVisibility): boolean {
	if (visibility === FieldAccess.Public) return true
	if (user.isAnon()) return false
	if (visibility === FieldAccess.Authenticated || user.has(Permission.ParcelSensitiveRead)) return true
	return visibility !== FieldAccess.Sensitive && user.has(visibility)
}
